import { BitrixUser } from '@services/AuthService/loadUserQuery';

import { DefaultUser } from './DefaultUser';

// Фабрика дефолтного пользователя
export const createDefaultUser: () => BitrixUser = () => new DefaultUser();
